import { useEffect, useLayoutEffect as _useLayoutEffect } from 'react';
export var useLayoutEffect = typeof document !== 'undefined' ? _useLayoutEffect : useEffect;
//# sourceMappingURL=useLayoutEffect.js.map